import { gql } from '@apollo/client';

export const GET_PRODUCT_SUMMARY_DATA = gql`
query getProductSummary($customerId:String , $isAdmin:Boolean){
  getProductSummary(customerId:$customerId , isAdmin:$isAdmin)
}
`
